/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../Stages/StagesCase";
import { getRequiredFields, validateFields } from "../statusChangeValidators";
import { PendingCase } from "../../../types/Products/PendingCase";

export const pendingCaseValidators = {
  [stagesCase.STAGE_COMPLETED]: (pendingCase: PendingCase) => {
    return validateFields(getRequiredFields(pendingCase, stagesCase.STAGE_COMPLETED), pendingCase);
  },
};
